export const parentDocumentAcknowledgementStatusTypePatcher = (data) => {
    return {
        acknowledgementStatus: data.acknowledgementStatus.map(status => {
            var _a, _b, _c, _d;
            return {
                __typename: 'ParentDocumentAcknowledgementStatus',
                childImage: status.childImage,
                childName: status.childName,
                recipient: status.recipient,
                ...(status.status === null || status.status === false
                    ? {
                        isAcknowledged: false,
                        parents: (_a = status.parents) !== null && _a !== void 0 ? _a : [],
                        acknowledgedById: null,
                        acknowledgedByName: null,
                        acknowledgedAt: null,
                    }
                    : {
                        isAcknowledged: true,
                        acknowledgedById: (_b = status.acknowledgedById) !== null && _b !== void 0 ? _b : '',
                        acknowledgedByName: (_c = status.acknowledgedByName) !== null && _c !== void 0 ? _c : '',
                        acknowledgedAt: (_d = status.acknowledgedAt) !== null && _d !== void 0 ? _d : '',
                        parents: null,
                    }),
            };
        }),
    };
};
